import Checkbox from './Checkbox';
import Select from './Select';
import MultiSelect from './MultiSelect';
import AutocompleteLocation from './AutocompleteLocation';
import PriceRange from './PriceRange';
import PriceGroup from './PriceGroup';
import RadioGroup from './RadioGroup';
import FavoriteFlatButton from './Favorite/FavoriteFlatButton';
import CommentFlatButton from './Comments/CommentFlatButton';
import ClaimFlatButton from './Claims/ClaimFlatButton';
import ScrollUp from './ScrollUp';
import ToggleViewMode from './ToggleViewMode';
import Pills from './Pills';

const Controls = {
  Checkbox,
  RadioGroup,
  Select,
  MultiSelect,
  AutocompleteLocation,
  PriceRange,
  PriceGroup,
  FavoriteFlatButton,
  CommentFlatButton,
  ClaimFlatButton,
  ScrollUp,
  ToggleViewMode,
  Pills
};

module.exports = Controls;



// WEBPACK FOOTER //
// ./src/ui/Controls/index.js